import React from 'react'

import useOnboardingDocusignComplete from '../../hooks/useOnboardingDocusignComplete'
import { Paths } from '../../../../routes/paths'

const DocuSignStep = () => {
  // needs to call API route, but not redirect to onboarding in some cases
  useOnboardingDocusignComplete()

  window.location.replace(Paths.newBusinessOnboardingComplete)

  return <></>
}

export default DocuSignStep
